<template>
  <b-badge
    :style="badgeConfig.badgeStyle"
    class="gr-status-badge"
  >
    {{ badgeConfig.badgeLabel }}
  </b-badge>
</template>

<script>
import { GR_STATUS } from "../../constants/productStock";

export default {
  name: "GrStatusBadge",
  props: {
    status: {
      type: String,
      default: null,
    },
    syncDt: {
      type: String,
      default: null,
    },
  },
  computed: {
    badgeConfig() {
      if (this.status === GR_STATUS.WAITING_BM) {
        return {
          badgeStyle: {
            backgroundColor: "#E3F2FD",
            color: "#3E495B",
          },
          badgeLabel: "รอผู้จัดการคลังอนุมัติ",
        };
      }
      
      if (this.status === GR_STATUS.WAITING_HQ) {
        return {
          badgeStyle: {
            backgroundColor: "#DBCCF4",
            color: "#3E495B",
          },
          badgeLabel: "รอสำนักงานใหญ่อนุมัติ",
        };
      }

      if (this.status === GR_STATUS.REJECTED) {
        return {
          badgeStyle: {
            backgroundColor: "#DD3333",
            color: "#FFFFFF",
          },
          badgeLabel: "ถูกปฏิเสธ",
        };
      }

      if (this.status === GR_STATUS.CANCELED) {
        return {
          badgeStyle: {
            backgroundColor: "#E9ECEF",
            color: "#3E495B",
          },
          badgeLabel: "ยกเลิก",
        };
      }

      if (this.status === GR_STATUS.COMPLETED) {
        return {
          badgeStyle: {
            backgroundColor: "#D8EFDD",
            color: "#3E495B",
          },
          badgeLabel: "อนุมัติแล้ว",
        };
      }

      return {
        badgeStyle: {
          backgroundColor: "#E9ECEF",
          color: "#3E495B",
        },
        badgeLabel: "ไม่พบสถานะ",
      };
    },
  },
};
</script>

<style scoped>
.gr-status-badge {
  font-size: 14px;
  font-weight: 400;
  padding: 0.35em 0.65em;
  border-radius: 20px;
}
</style>
